export const MAX_ICON_SIZE_IN_KB = 1024;

export const ICON_TITLE_REGEX = /^[^$.]*$/;
